export type Bonus = {
  id: string
  value: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    id: 'BONUS 01',
    value: '$49 value',
    title: 'The Level Finder 360',
    description:
      'Place any new student in the correct level in under 5 minutes. No more guessing on day one.',
  },
  {
    id: 'BONUS 02',
    value: '$54 value',
    title: 'Physical Express',
    description:
      '15-minute physical routines built into your sessions. More performance, fewer injuries, zero extra equipment needed.',
  },
  {
    id: 'BONUS 03',
    value: '$59 value',
    title: 'Nutrition & Court Performance',
    description:
      'What to eat, drink and avoid before, during and after sessions. Better student energy, better results.',
  },
  {
    id: 'BONUS 04',
    value: '$64 value',
    title: 'The Rainy Day Plan',
    description:
      '10 complete indoor sessions ready to deliver. Never cancel a class due to weather again.',
  },
  {
    id: 'BONUS 05',
    value: '$49 value',
    title: 'The Survival Kit',
    description:
      'Emergency protocols for mixed groups, no equipment, late starts or difficult student situations.',
  },
  {
    id: 'BONUS 06',
    value: '$43 value',
    title: 'The Weekly Organisation Pack',
    description:
      'Attendance sheets, payment tracking and weekly planning templates. Run your coaching like a professional business.',
  },
]
